import { ClipboardCheck, Hammer, ShoppingBasket } from "lucide-react";
import type { LucideIcon } from "lucide-react";

/**
 * The app is split into workspaces. `assessment` carries everything from the
 * assessment phase; `implementation` is the lean B2B build-phase view (Timeline,
 * MVP Delivery Board, Build Planner); `b2c-implementation` is the B2C MVP board,
 * run in stages, workstreams, iterations and marathons (migration 0138). Which
 * workspaces a user can see is driven by their `profiles.workspaces` row in
 * Supabase (migration 0119).
 */
export const Workspace = {
  ASSESSMENT: "assessment",
  IMPLEMENTATION: "implementation",
  B2C_IMPLEMENTATION: "b2c-implementation",
} as const;

export type WorkspaceId = (typeof Workspace)[keyof typeof Workspace];

export interface WorkspaceMeta {
  id: WorkspaceId;
  label: string;
  /** short uppercase tag shown under the logo */
  tag: string;
  icon: LucideIcon;
}

const ASSESSMENT_META: WorkspaceMeta = {
  id: Workspace.ASSESSMENT,
  label: "Assessment",
  tag: "Assess",
  icon: ClipboardCheck,
};
const IMPLEMENTATION_META: WorkspaceMeta = {
  id: Workspace.IMPLEMENTATION,
  label: "Implementation",
  tag: "Build",
  icon: Hammer,
};

const B2C_IMPLEMENTATION_META: WorkspaceMeta = {
  id: Workspace.B2C_IMPLEMENTATION,
  label: "B2C Implementation",
  tag: "B2C",
  icon: ShoppingBasket,
};

export const WORKSPACES: WorkspaceMeta[] = [
  ASSESSMENT_META,
  IMPLEMENTATION_META,
  B2C_IMPLEMENTATION_META,
];

export function workspaceMeta(id: WorkspaceId): WorkspaceMeta {
  return WORKSPACES.find((w) => w.id === id) ?? ASSESSMENT_META;
}

export function isWorkspaceId(value: string): value is WorkspaceId {
  return WORKSPACES.some((w) => w.id === value);
}
